/* eslint-disable */
// import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
// import authActions from '../../redux/features/auth/actions';
// import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
// import config from '../../config/config';
// import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
// import { usePopupManager } from '../../providers/PopupManager/PopupManager';
// import TransMainDashboard from '../../components/TransitionPageComp/TransMainDashboard';
// import styles from './TransitionPage.module.css';

// const TransitionPage = ({
//   isAuthenticated,
//   authPolicies,
//   currentUserId,
// }) => {

//   const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
//   const { showLoading } = usePopupManager();

//   useEffect(() => {
//     if (
//       authorizedApps.length &&
//       !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
//     ) {
//       showLoading();
//       window.location.replace(config.HOME_UI_BASE_URL);
//     }
//   }, [authorizedApps, currentUserId]);

//   return (
//     <div className={styles.container}>
//       <TransMainDashboard />
//     </div>
//   )
// }

// TransitionPage.propTypes = {
//   isAuthenticated: PropTypes.bool.isRequired,
//   authPolicies: PropTypes.object.isRequired,
//   currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
//     .isRequired,
// };
  
// export default connect(({ auth, userProfile }) => ({
//   isAuthenticated: auth.isAuthenticated,
//   authPolicies: auth.authPolicies,
//   currentUserId: userProfile.userId,
//   setAuthToken: authActions.setAuthToken,
// }))(TransitionPage);


import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import TransMainDashboard from '../../components/TransitionPageComp/TransMainDashboard';
import TransitionHiringDashboardComp from '../../components/TransitionPageComp/TransitionHiringDashboardComp/TransitionHiringDashboardComp';
import TransitionPOStatusComp from '../../components/TransitionPageComp/TransitionPOStatusComp/TransitionPOStatusComp';
import TransitionFinanceDashboardComp from '../../components/TransitionPageComp/TransitionFinanceDashboardComp/TransitionFinanceDashboardComp';
import TransitionSLADashboardComp from '../../components/TransitionPageComp/TransitionSLADashboardComp/TransitionSLADashboardComp';

import TabSwitcher from '../../components/FileUploadComp/TabSwitcher/TabSwitcher';
import styles from './TransitionPage.module.css';

const TransitionPage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  const [selectedTab, setSelectedTab] = useState('Overall Transition Status Dashboard');

  // const availableTabs = ['Overall Transition Status Dashboard', 'Hiring Dashboard', 'PO Status Dashboard', 'Finance Dashboard', 'SLA Dashboard'];
  const availableTabs = ['Overall Transition Status Dashboard','Hiring Dashboard', 'PO Status Dashboard','Finance Dashboard','SLA Dashboard'];



  return (
    <div className={styles.container}>
      {/* <TransMainDashboard /> */}
      <TabSwitcher
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        tabs={availableTabs}
      />

      {selectedTab === 'Overall Transition Status Dashboard' ? (
        <TransMainDashboard />
      ) : selectedTab === 'Hiring Dashboard' ? (
        <TransitionHiringDashboardComp />
        // <h2>Welcome To Hiring Dashboard</h2>
      ) 
      : selectedTab === 'PO Status Dashboard' ? (
        <TransitionPOStatusComp />
        // <h2>Welcome To PO Status Dashboard</h2>
      ) 
      : selectedTab === 'Finance Dashboard' ? (
        <TransitionFinanceDashboardComp />
        // <h2>Welcome To Finance Status Dashboard</h2>
      ) 
      : selectedTab === 'SLA Dashboard' ? (
        <TransitionSLADashboardComp />
        // <h2>Welcome To SLA Dashboard</h2>
      ) 
      : null}
    </div>
  )
}

TransitionPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(TransitionPage);
